let baseURL = 'https://bridgetalk.org/api/v1/';
// let baseURL = 'https://btalkserver.com/api/v1/';
// let baseURL = 'http://192.168.1.100:3000/api/v1/';

export default baseURL;
